import React from 'react';
import { Star } from 'lucide-react';
import { mockData } from '../data/mock';

/**
 * Elegant testimonial strip — 3 quotes with 5-star rating.
 * Works on any background (uses inherited colors).
 */
const TestimonialStrip = ({ title = 'Loved by Real Couples', accent = '& Families' }) => (
  <section className="py-20 bg-ivory texture-linen" data-testid="testimonial-strip">
    <div className="container mx-auto px-6">
      <div className="text-center mb-12 max-w-2xl mx-auto">
        <p className="text-gold text-sm tracking-[0.3em] uppercase mb-3">In Their Words</p>
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy">
          {title} <span className="text-gold italic">{accent}</span>
        </h2>
        <div className="flex items-center justify-center gap-3 mx-auto mt-5">
          <div className="h-px w-16 bg-gradient-to-r from-transparent to-gold" />
          <div className="w-1.5 h-1.5 rotate-45 bg-gold" />
          <div className="h-px w-16 bg-gradient-to-l from-transparent to-gold" />
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {mockData.testimonials.map((t, i) => (
          <figure
            key={i}
            className="bg-cream border border-gold/25 rounded-lg p-8 shadow-sm hover:shadow-xl transition-all flex flex-col"
            data-testid={`testimonial-${i}`}
          >
            <div className="flex gap-1 mb-4">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} className="h-4 w-4 text-gold fill-gold" />
              ))}
            </div>
            <blockquote className="font-editorial text-lg text-navy italic leading-relaxed flex-grow mb-6">
              &ldquo;{t.text}&rdquo;
            </blockquote>
            <figcaption>
              <p className="font-serif text-navy font-semibold">{t.name}</p>
              <p className="text-gold text-xs tracking-[0.2em] uppercase mt-1">{t.event}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export default TestimonialStrip;
